const actions = {
  USER_BEGIN:   'USER_BEGIN',
  USER_SUCCESS: 'USER_SUCCESS',
  USER_ERR:     'USER_ERR',

  userBegin: () => {
    return {
      type: actions.USER_BEGIN,
    };
  },

  userSuccess: (data) => {
    return {
      type: actions.USER_SUCCESS,
      data
    };
  },

  userErr: () => {
    return {
      type: actions.USER_ERR,
    };
  },
};

export default actions;
